import relayPowerTypes from '@/constants/relay-power-types'
import relayTypes from '@/constants/relay-types'

export default {
    data() {
        return {
            power_type: relayPowerTypes.BATTERY.type,
            solar_power_panel_type: null,
            solar_power_wattage: null,
            ac_power_circuit_amps: null,
            ac_power_source_type: null,
            ac_power_voltage: null,
            battery_type: null,
            is_battery_external: false,
        }
    },

    watch: {
        /**
         * When changing relay types, reset its power fields, but
         * only do so if the type has already been set.
         * @param newValue
         * @param oldValue
         */
        type(newValue, oldValue) {
            if (oldValue !== null) {
                this.resetPowerFields(true)
            }
        },

        /**
         * When changing power type (AC/Battery/Solar), reset all
         * the power fields.
         */
        power_type() {
            this.resetPowerFields(false)
        },

        /**
         * If changing from external -> internal battery, clear
         * out the battery type, internal batteries don't have one
         * @param newValue
         */
        is_battery_external(newValue) {
            if (newValue === false) {
                this.battery_type = null
            }
        },
    },

    methods: {
        resetPowerFields(relayTypeChanged) {
            const fieldsByType = {
                [relayPowerTypes.AC.type]: ['ac_power_source_type', 'ac_power_voltage', 'ac_power_circuit_amps'],
                [relayPowerTypes.BATTERY.type]: ['is_battery_external', 'battery_type'],
                [relayPowerTypes.SOLAR.type]: ['solar_power_panel_type', 'solar_power_wattage'],
            }

            // ensure power fields are cleared for other power types
            Object.entries(fieldsByType)
                .flatMap(([powerType, fields]) => (powerType !== this.power_type ? fields : []))
                .forEach((field) => {
                    this[field] = null
                })

            if (this.power_type === relayPowerTypes.BATTERY.type) {
                if (this.type === relayTypes.EDGE.type || this.type === relayTypes.ADVANCED.type) {
                    // edge + advanced relays must have internal battery
                    this.is_battery_external = false
                } else if (relayTypeChanged) {
                    // if was an edge relay and is now a hasty,
                    // reset is_battery_external
                    this.is_battery_external = null
                }

                if (!this.is_battery_external) {
                    this.battery_type = null
                }
            }
        },
    },
}
